const FTXml = (values, initialValues, fixedValues, random_number) => (
  `<?xml version='1.0' encoding='UTF-8'?> <FTSingleCreditRequest> <SessionID>${initialValues.sendersFinancialInstitutionCode ||
  values.sendersFinancialInstitutionCode
  }${fixedValues.time_stamp
  }${random_number}</SessionID><DestinationInstitutionCode>${initialValues.destinationInstitutionCode ||
  values.destinationInstitutionCode
  }</DestinationInstitutionCode> <ChannelCode>${initialValues.channelCode || values.channelCode
  }</ChannelCode>
  <BeneficiaryAccountName>${initialValues.beneficiaryAccountName || values.beneficiaryAccountName
  }</BeneficiaryAccountName><BeneficiaryAccountNumber>${initialValues.beneficiaryAccountNumber || values.beneficiaryAccountNumber
  }</BeneficiaryAccountNumber>  <BeneficiaryBankVerificationNumber>${initialValues.beneficiaryBankVerificationNumber ||
  values.beneficiaryBankVerificationNumber
  }</BeneficiaryBankVerificationNumber> <BeneficiaryKYCLevel>${initialValues.beneficiaryKYCLevel ||
  values.beneficiaryKYCLevel
  }</BeneficiaryKYCLevel>
  <OriginatorAccountName>${initialValues.originatorAccountName || values.originatorAccountName
  }</OriginatorAccountName>
  <OriginatorAccountNumber>${initialValues.originatorAccountNumber || values.originatorAccountNumber
  }</OriginatorAccountNumber> <OriginatorBankVerificationNumber>${initialValues.originatorBankVerificationNumber ||
  values.originatorBankVerificationNumber
  }</OriginatorBankVerificationNumber> <OriginatorKYCLevel>${initialValues.originatorKYCLevel || values.originatorKYCLevel
  }</OriginatorKYCLevel>
  <TransactionLocation>${initialValues.transactionLocation || values.transactionLocation
  }</TransactionLocation>
  <Narration>${initialValues.narration || values.narration
  }</Narration> <PaymentReference>${initialValues.paymentReference || values.paymentReference
  }</PaymentReference> <Amount>${initialValues.amount || values.amount}</Amount>
  </FTSingleCreditRequest>`
);

export default FTXml;
